import { render, staticRenderFns } from "./SidebarStar.vue?vue&type=template&id=6ff8f4a5&scoped=true"
import script from "./SidebarStar.vue?vue&type=script&lang=js"
export * from "./SidebarStar.vue?vue&type=script&lang=js"
import style0 from "./SidebarStar.vue?vue&type=style&index=0&id=6ff8f4a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8f4a5",
  null
  
)

export default component.exports